module.exports = __webpack_public_path__ + "static/media/img_hourly_01.8e04abf2.png";